import think from '../../../assets/images/customer-logos/think.svg';
import zyoin from '../../../assets/images/customer-logos/zyoin.png';
import hashedin from '../../../assets/images/customer-logos/hashedin.png';
import deloitteusi from '../../../assets/images/customer-logos/deloitteusi.png';
import nomiso from '../../../assets/images/customer-logos/nomiso.png';
import thoucentric from '../../../assets/images/customer-logos/thoucentric.png';
import cbsiglobal from '../assets/logos/cbsiglobal.webp';
import itc from '../assets/logos/itc.webp';
import novumlake from '../assets/logos/novumlake.jpg';
import sucimani from '../assets/logos/sucimani.jpeg';
import swissnex from '../assets/logos/swissnex.png';

const logos = [
  { src: think, alt: 'Think' },
  { src: zyoin, alt: 'Zyoin' },
  { src: sucimani, alt: 'Sucimani' },
  { src: novumlake, alt: 'Novumlake' },
  { src: hashedin, alt: 'HashedIn' },
  { src: cbsiglobal, alt: 'CBSI Global' },
  { src: deloitteusi, alt: 'Deloitte USI' },
  { src: swissnex, alt: 'Swissnex' },
  { src: itc, alt: 'ITC' },
  { src: thoucentric, alt: 'Thoucentric' },
  { src: nomiso, alt: 'Nomiso' },
];

export default function LogoStrip() {
  return (
    <section className="bg-background py-12 border-b border-border overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        <p className="text-center text-sm uppercase tracking-widest text-muted-foreground mb-8">
          Built on technology behind 1 lakh+ real interviews at
        </p>
      </div>
      <div className="relative">
        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-background to-transparent" />

        <div className="flex overflow-hidden">
          <div className="flex shrink-0 items-center gap-16 pr-16 animate-[logo-marquee_40s_linear_infinite]">
            {logos.map((logo, i) => (
              <img
                key={`a-${i}`}
                src={logo.src}
                alt={logo.alt}
                className="h-10 w-auto object-contain grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
              />
            ))}
          </div>
          <div
            aria-hidden="true"
            className="flex shrink-0 items-center gap-16 pr-16 animate-[logo-marquee_40s_linear_infinite]"
          >
            {logos.map((logo, i) => (
              <img
                key={`b-${i}`}
                src={logo.src}
                alt=""
                className="h-10 w-auto object-contain grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
              />
            ))}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes logo-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-100%); }
        }
      `}</style>
    </section>
  );
}
